import { Component } from '@angular/core';

@Component({
  selector: 'app-index-ceo-section',
  imports: [],
  templateUrl: './index-ceo-section.html',
  styleUrl: './index-ceo-section.scss',
})
export class IndexCeoSection {

}
